export default __webpack_public_path__ + "static/media/xiaomi.0afafd47.svg";